import './config';
import {apiBaseUrl} from './config';
import {getBaseHeader} from './utils';
import SfpBaseService from './sfp-base-service';

const PPI_INVESTMENT_PROJECT_GRANTS = 'ppis/investments/projects/grants';

export default class PPIInvestmentProjectGrantService extends SfpBaseService {

  static createPPIInvestmentProjectGrant(ppi_investment_project_grant) {
    const body = JSON.stringify({ppi_investment_project_grant});
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/${PPI_INVESTMENT_PROJECT_GRANTS}`, {body, headers, method: "POST"})
      .then(super.returnResponse);
  }

  static updatePPIInvestmentProjectGrant(ppi_investment_project_grant_id, ppi_investment_project_grant) {
    const body = JSON.stringify({ppi_investment_project_grant});
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/ppis/${ppi_investment_project_grant_id}/investment/project/grant`, {body, headers, method: "PUT"})
      .then(super.returnResponse);
  }

  static deletePPIInvestmentProjectGrant(ppi_investment_project_grant) {
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/ppis/${ppi_investment_project_grant.id}/investment/project/grant`, {headers, method: "DELETE"})
      .then(super.returnResponse);
  }

}



// WEBPACK FOOTER //
// ./src/service/sfp/ppi-investment-project-grant-service.js